import React from "react";
// import ReactOwlCarousel from "react-owl-carousel";
// import "../../node_modules/owl.carousel/dist/assets/owl.carousel.css"
import Product1 from "../assets/images/product1.jpg"
import Product2 from "../assets/images/product2.jpg"



function ImageCarousel() {
 
  return (
   <>


{/* <ReactOwlCarousel className='owl-theme' loop dots autoplay margin={10} items={2} >
    <div className='item'>
        <div className="text-center">
            <img src={Product1} className="w-100 rounded-3"/>
            <h5 className="font_12 mb-0 mt-2">Aadhaar Masking</h5>
        </div>
    </div>
    <div className='item'>
        <div className="text-center">
            <img src={Product2} className="w-100 rounded-3"/>
            <h5 className="font_12 mb-0 mt-2">Aadhaar Masking</h5>
        </div>
    </div>
    <div className='item'>
        <div className="text-center">
            <img src={Product1} className="w-100 rounded-3"/>
            <h5 className="font_12 mb-0 mt-2">Aadhaar Masking</h5>
        </div>
    </div>
    <div className='item'>
        <div className="text-center">
            <img src={Product2} className="w-100 rounded-3"/>
            <h5 className="font_12 mb-0 mt-2">Aadhaar Masking</h5>
        </div>
    </div>
    </ReactOwlCarousel> */}
   </>
  )
}

export default ImageCarousel